import { ListActionTypes } from './actionTypes';

export interface SelectedList {
  id: string;
  name: string;
  path: string;
  ai_details?: any;
  ai_list_config?: any;
  type?: string;
  num_items?: number;
  owner?: {
    id: number;
    first_name: string;
    last_name: string;
  };
}

export type ListState = {
  formattedProspectLists: any[];
  listQueryParams: any;
  selectedList: SelectedList | null;
  showReassignListDialog: boolean;
  showShareListDialog: boolean;
  showDeleteListDialog: boolean;
  listToManage: string | null;
  listMembersRefetchKey: number;
};

export const initialListState: ListState = {
  formattedProspectLists: [],
  listQueryParams: {},
  selectedList: null,
  showReassignListDialog: false,
  showShareListDialog: false,
  showDeleteListDialog: false,
  listToManage: null,
  listMembersRefetchKey: 0,
};

export const listReducer = (
  state: ListState = initialListState,
  action: any
): ListState => {
  switch (action.type) {
    case ListActionTypes.SET_FORMATTED_PROSPECT_LISTS:
      return {
        ...state,
        formattedProspectLists: action.payload,
      };
    case ListActionTypes.SET_LIST_QUERY_PARAMS:
      return {
        ...state,
        listQueryParams: action.payload,
      };
    case ListActionTypes.SET_SELECTED_LIST:
      return {
        ...state,
        selectedList: action.payload,
      };
    case ListActionTypes.SET_SHOW_REASSIGN_LIST_DIALOG:
      return {
        ...state,
        showReassignListDialog: action.payload,
      };
    case ListActionTypes.SET_SHOW_SHARE_LIST_DIALOG:
      return {
        ...state,
        showShareListDialog: action.payload,
      };
    case ListActionTypes.SET_SHOW_DELETE_LIST_DIALOG:
      return {
        ...state,
        showDeleteListDialog: action.payload,
      };
    case ListActionTypes.SET_LIST_TO_MANAGE:
      return {
        ...state,
        listToManage: action.payload,
      };
    case ListActionTypes.TRIGGER_LIST_MEMBERS_REFETCH:
      return {
        ...state,
        listMembersRefetchKey: state.listMembersRefetchKey + 1,
      };

    default:
      return state;
  }
};
